<template>
  <div class="sub-page-v2">
    <div class="page-hero-small">
      <h1>{{ $t('common.news') }}</h1>
    </div>
    <div class="container-v2 page-body-v2">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsIndexV2'
}
</script>
